/**
 * Urlaub & Krank (/urlaub, Phase 3): vier Tabs —
 * Anträge (Workflow AP 3.2), Team-Übersicht (Monats-Matrix),
 * Konten (AP 3.3, Gate personal_schreiben), Krank (AP 3.4).
 * Entscheidung Krank-UI: eigener Tab hier statt /abwesenheiten —
 * Vorbild netzfabriks-erp (VacationPage + SickLeavePage im HR-Bereich).
 */

import { useState } from "react"
import { AccountsTab } from "@/components/vacation/AccountsTab"
import { LeaveRequestsTab } from "@/components/vacation/LeaveRequestsTab"
import { SickLeavesTab } from "@/components/vacation/SickLeavesTab"
import { TeamOverviewTab } from "@/components/vacation/TeamOverviewTab"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useCan } from "@/lib/permissions"

export function VacationPage() {
  const canWrite = useCan("personal_schreiben")
  const [tab, setTab] = useState("requests")

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Urlaub &amp; Krank</h1>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="requests">Anträge</TabsTrigger>
          <TabsTrigger value="team">Team-Übersicht</TabsTrigger>
          {canWrite && <TabsTrigger value="accounts">Konten</TabsTrigger>}
          <TabsTrigger value="sick">Krank</TabsTrigger>
        </TabsList>

        <TabsContent value="requests">
          <LeaveRequestsTab />
        </TabsContent>
        <TabsContent value="team">
          <TeamOverviewTab />
        </TabsContent>
        {canWrite && (
          <TabsContent value="accounts">
            <AccountsTab />
          </TabsContent>
        )}
        <TabsContent value="sick">
          <SickLeavesTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
